<div class="content-width">


  <div id="printview" *ngIf="loanDetailWrapper!=null">
    <div class="pageHeader" *ngIf="responseDetails!=null">Loan Details</div>

    <div class="ui-g container grid-conatiner">

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Fannie Mae Loan Number:</div>
        <div class="ui-g-4 details"> {{loanDetailWrapper.loanNumber}} </div>
        <div class="ui-g-2 label-font">FHA Case Number:</div>
        <div class="ui-g-4 details"> {{loanDetailWrapper.fhaCaseNum}} </div>
      </div>


      <div class="ui-g-12">
        <div class="ui-g-2 label-font">Servicer Number:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.servicerNum}}</div>
        <div class="ui-g-2 label-font">Scheduled Payment Status:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.schdPymntStatus}}</div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Product Type:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.productType}}</div>
        <div class="ui-g-2 label-font">Loan Status:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.loanStatus}}</div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-2 label-font">Interest Rate Type:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.intRateType}}</div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Payment Plan:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.paymentPlan}}</div>
        <div class="ui-g-2 label-font">Monthly Taxes/Insurance:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.tiAmt | currency}}</div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-2 label-font">Monthly Scheduled Payment:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.schdlPymnt | currency}}</div>
        <div class="ui-g-2 label-font">Loan Term:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.loanTerm}}</div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Interest Rate:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.interestRate}}%</div>
        <div class="ui-g-2 label-font">Margin:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.mortgageMargin}}%</div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-2 label-font">Funding Date:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.fundingDate}}</div>
        <div class="ui-g-2 label-font">Purchase Date:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.purchaseDate}}</div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">Next Adjusted Date:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.nextAdjDate}}</div>
        <div class="ui-g-2 label-font">Lender Loan ID:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.lenderLoanId}}</div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-2 label-font">Address:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.streetAddress}}</div>
        <div class="ui-g-2 label-font">City:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.city}}</div>
      </div>

      <div class="ui-g-12 strip-color">
        <div class="ui-g-2 label-font">State:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.state}}</div>
        <div class="ui-g-2 label-font">Zip:</div>
        <div class="ui-g-4 details">{{loanDetailWrapper.zip}}</div>
      </div>

    </div>

    <!-- Loan Balances -->
    <div class="ui-g container grid-conatiner">
      <div class="ui-g-6 grid-conatiner">

        <div class="ui-g-12 grid-header">Current Loan Balances</div>


        <div class="ui-g-12">
          <div class="ui-g-8 label-font">Loan Balance:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.loanBalanceCurr | currency}}</div>
        </div>

        <div class="ui-g-12 strip-color">
          <div class="ui-g-8 label-font">Servicing Fee Set-Aside:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.srvcngFeeCurr | currency}}</div>
        </div>

        <div class="ui-g-12">
          <div class="ui-g-8 label-font">Repairs Set-Aside:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.repairsFeeCurr | currency}}</div>
        </div>

        <div class="ui-g-12 strip-color">
          <div class="ui-g-8 label-font">First Year Property Charges:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.firstYrPropFeeCurr | currency}}</div>
        </div>

        <div class="ui-g-12">
          <div class="ui-g-8 label-font">Taxes/Insurance Set-Aside:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.tiCurr | currency}}</div>
        </div>

        <div class="ui-g-12 strip-color">
          <div class="ui-g-8 label-font">Line of Credit Reserve:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.lineofCreditResCurr | currency}}</div>
        </div>

        <div class="ui-g-12 ">
          <div class="ui-g-8 label-font">Net Line of Credit:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.netLineofCreditCurr | currency}}</div>
        </div>

        <div class="ui-g-12 strip-color">
          <div class="ui-g-8 label-font">Unscheduled Loan Balance:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.ulbCurr | currency}}</div>
        </div>

        <div class="ui-g-12 ">
          <div class="ui-g-8 label-font">Principal Limit:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.prncplLimitCurr | currency}}</div>
        </div>

        <div class="ui-g-12 strip-color">
          <div class="ui-g-8 label-font">Net Principal Limit:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.netPrncplLimitCurr | currency}}</div>
        </div>

        <div class="ui-g-12 ">
          <div class="ui-g-8 label-font">Outstanding Cash Balance:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.outstandingCashBalCurr | currency}}</div>
        </div>

      </div>
      <div class="ui-g-6 grid-conatiner" *ngIf="!isExternal">

        <div class="ui-g-12 grid-header">Begin Loan Balances</div>
        <div class="ui-g-12">
          <div class="ui-g-8 label-font">Begin Loan Balance:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.loanBalanceBegin | currency}}</div>
        </div>

        <div class="ui-g-12 strip-color">
          <div class="ui-g-8 label-font">Begin Servicing Fee Set-Aside:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.srvcngFeeBegin | currency}}</div>
        </div>

        <div class="ui-g-12">
          <div class="ui-g-8 label-font">Begin Repairs Set-Aside:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.repairsFeeBegin | currency}}</div>
        </div>

        <div class="ui-g-12 strip-color">
          <div class="ui-g-8 label-font">Begin First Year Property Charges:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.firstYrPropFeeBegin | currency}}</div>
        </div>

        <div class="ui-g-12">
          <div class="ui-g-8 label-font">Begin Taxes/Insurance Set-Aside:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.tiBegin | currency}}</div>
        </div>

        <div class="ui-g-12 strip-color">
          <div class="ui-g-8 label-font">Begin Line of Credit Reserve:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.lineofCreditResBegin | currency}}</div>
        </div>

        <div class="ui-g-12 ">
          <div class="ui-g-8 label-font">Begin Net Line of Credit:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.netLineofCreditBegin | currency}}</div>
        </div>

        <div class="ui-g-12 strip-color">
          <div class="ui-g-8 label-font">Begin Unscheduled Loan Balance:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.ulbBegin | currency}}</div>
        </div>

        <div class="ui-g-12 ">
          <div class="ui-g-8 label-font">Begin Principal Limit:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.prncplLimitBegin | currency}}</div>
        </div>

        <div class="ui-g-12 strip-color">
          <div class="ui-g-8 label-font">Begin Net Principal Limit:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.netPrncplLimitBegin | currency}}</div>
        </div>

        <div class="ui-g-12 ">
          <div class="ui-g-8 label-font">Begin Outstanding Cash Balance:</div>
          <div class="ui-g-4 details">{{loanDetailWrapper.outstandingCashBalBegin | currency}}</div>
        </div>
      </div>

    </div>
    <!-- Purchasing Details -->
    <div class="ui-g container grid-conatiner">
      <div class="ui-g-12 grid-header">Purchasing Details</div>
      <div class="ui-g-12">
        <div class="ui-g-6 label-font">Closing Date:</div>
        <div class="ui-g-6 details">{{loanDetailWrapper.closingDate}}</div>
      </div>
      <div class="ui-g-12 strip-color">
        <div class="ui-g-6 label-font">Borrower Birthdate:</div>
        <div class="ui-g-6 details">{{loanDetailWrapper.borrowersDOB}}</div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-6 label-font">MCA/APV Amount:</div>
        <div class="ui-g-6 details">{{loanDetailWrapper.maxClaimAmt | currency}}</div>
      </div>
      <div class="ui-g-12 strip-color">
        <div class="ui-g-6 label-font">Expected Average Interest Rate:</div>
        <div class="ui-g-6 details">{{loanDetailWrapper.expAvgIntRate}}%</div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-6 label-font">Service Fee:</div>
        <div class="ui-g-6 details">{{loanDetailWrapper.srvcngFee | currency}}</div>
      </div>
      <div class="ui-g-12 strip-color">
        <div class="ui-g-6 label-font">UPB at Purchase:</div>
        <div class="ui-g-6 details">{{loanDetailWrapper.upb | currency}}</div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-6 label-font">98% Max Claim Amount:</div>
        <div class="ui-g-6 details">{{loanDetailWrapper.ninetyEightPctMaxClaimAmount | currency}}</div>
      </div>

    </div>
    <div  class="button-right-cancel">
      <a (click)="showloanDetailWrappers()" class="detail-link">Transactions</a>
      <br/>
      <button fmButton type="button" label="Cancel" (click)="cancel()" class="buttonmargin"></button>
    </div>
  </div>
  <app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>
</div>
